"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var action_types_1 = require("./action-types");
var default_locale_list_1 = tslib_1.__importDefault(require("./default-locale-list"));
exports.ROOT_KEY = 'translations';
exports.DEFAULT_LOCALE = {
    dir: 'ltr',
    code: 'en_US',
    intlCode: 'en-US',
    label: 'English [U.S.]'
};
exports.DEFAULT_CLIENT_BUNDLE_NAME = 'goalquest';
exports.DEFAULT_NATIVE_BUNDLE_NAME = 'salesmakerNative';
/******************
 * Initial state
 */
exports.defaultState = {
    bundleList: {},
    localeList: default_locale_list_1.default,
    userLocale: exports.DEFAULT_LOCALE.code
};
function setUserLocale(state, action) {
    var userLocale = action.userLocale;
    return tslib_1.__assign({}, state, { userLocale: userLocale });
}
exports.setUserLocale = setUserLocale;
function setClientLocalList(state, action) {
    var localeList = action.localeList;
    return tslib_1.__assign({}, state, { localeList: localeList });
}
exports.setClientLocalList = setClientLocalList;
function setLocaleBundle(state, action) {
    var _a;
    var code = action.code, bundle = action.bundle, name = action.name;
    var ids = get_1.default(state, "bundleList." + code + ".ids", []);
    var properties = get_1.default(state, "bundleList." + code + ".properties", {});
    return tslib_1.__assign({}, state, { bundleList: tslib_1.__assign({}, state.bundleList, (_a = {}, _a[code] = {
            ids: tslib_1.__spread(ids, [
                code + "_" + name
            ]),
            properties: tslib_1.__assign({}, properties, bundle.properties)
        }, _a)) });
}
exports.setLocaleBundle = setLocaleBundle;
/******************
 * Reducer
 */
function translationsReducer(state, action) {
    if (state === void 0) { state = exports.defaultState; }
    switch (action.type) {
        case action_types_1.SET_USER_LOCALE:
            return setUserLocale(state, action);
        case action_types_1.SET_LOCALE_LIST:
            return setClientLocalList(state, action);
        case action_types_1.SET_LOCALE_BUNDLE:
            return setLocaleBundle(state, action);
        default:
            return state;
    }
}
exports.default = translationsReducer;
//# sourceMappingURL=reducers.js.map